import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  infoBlock: {
    marginVertical: 8,
    gap: 4,
  },
  infoLine: {
    fontSize: 9,
  },
  infoLabel: {
    fontWeight: 'bold',
  },
  infoLabelSub: {
    fontWeight: 'normal',
    color: '#000',
  },
  infoValue: {
    color: '#000',
  }
})

interface MainFieldsOfPDFProps {
  infoFields: {
    label: string,
    subLabel?: string,
    value: string
  }[]
}


const MainFieldsOfPDF: React.FC<MainFieldsOfPDFProps> = ({ infoFields }) => {
  return (
    <View style={styles.infoBlock}>
      {infoFields.map((info, index) => (
        <Text key={index} style={styles.infoLine}>
          <Text style={styles.infoLabel}>{info.label}</Text>
          {info.subLabel && (
            <Text style={styles.infoLabelSub}>({info.subLabel})</Text>
          )}
          <Text style={styles.infoValue}>: {info.value}</Text>
        </Text>
      ))}
    </View>
  )
}

export default MainFieldsOfPDF